import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-deprecated',
  standalone: true,
  imports: [MatCardModule, MatIconModule],
  templateUrl: './deprecated.component.html',
  styleUrl: './deprecated.component.scss',
})
export class DeprecatedComponent {
  message = input.required<string>();
  icon = input<string>('info');
  type = input<'primary' | 'accent' | 'warn'>('primary');
}
